<template>
  <base-dialog
    v-model="show"
    @close="close"
    :loading="loading"
    fullscreen
    disabledAction
    content-class="diable-dialog-scroll"
  >
    <template v-slot:title> {{ title }} </template>
    <div class="d-flex flex-column full-height">
      <div class="flex-grow-1 overflow-auto">
        <base-serve-table
          v-if="show"
          ref="table"
          :api="api"
          :headers="headers"
          :params.sync="params"
          :defaultParams="default_params"
          sync-params
        >
          <template v-slot:[`item.action`]="{ item }">
            <div class="d-flex">
              <base-button-group
                class="full-width"
                :items="menus"
                :value="item"
                forceInList
              ></base-button-group>
            </div>
          </template>
        </base-serve-table>
      </div>
    </div>
    <FeatureInfo ref="featureDetail" />
  </base-dialog>
</template>

<script>
import { API_FEATURE } from '@api'
import { replaceLink } from '@utils'
import FeatureInfo from './feature-dialog.vue'
// import FeatureInfo from '../../map/layer-control/FeatureInfo.vue'
export default {
  components: { FeatureInfo },
  props: {
    id: { type: Number, required: true },
    title: { type: String, default: 'Dữ liệu' },
    fields: { type: Array, required: true },
  },
  data: (vm) => ({
    show: false,
    loading: false,
    default_params: {
      // sort: 'created_at',
    },
    headers: [],
    params: {},
    menus: [
      {
        title: 'Xem chi tiết dữ liệu',
        icon: 'mdi-information-outline',
        handler: (item) => {
          return vm.onShowDetail(item)
        },
      },
    ],
  }),
  computed: {
    api() {
      return API_FEATURE.updateOption({
        url: replaceLink(API_FEATURE.getUrl(), { id: this.id }),
      })
    },
  },
  watch: {
    fields: {
      handler(value) {
        this.setFields(this.fields)
      },
      immediate: true,
    },
  },
  methods: {
    open() {
      this.params = { page: null }
      this.show = true
    },
    close() {
      this.show = false
      this.loading = false
    },
    onSubmit() {
      this.close()
    },
    onShowDetail(item) {
      let temp = { data: item, fields: this.fields }
      this.$refs.featureDetail.open(temp)
    },
    setFields(fields) {
      this.headers = [
        ...convertFieldsToHeader(fields),
        {
          trans: 'field.action',
          value: 'action',
          sortable: false,
          hidden: false,
          width: '150px',
          align: 'center',
        },
      ]
    },
  },
}

export function convertFieldsToHeader(fields) {
  let MAX_FIELD_SHOW_INIT = 5
  return fields.reduce((acc, field, index) => {
    let type = field.type
    let format = null
    if (['array', 'geometry'].includes(field.type)) {
      return acc
    }
    acc.push({
      value: field['code'],
      type,
      text: field['name'],
      sortable: false,
      filterable: false,
      hidden: index >= MAX_FIELD_SHOW_INIT,
      format,
    })
    return acc
  }, [])
}
</script>

<style scoped></style>
